import * as tslib_1 from "tslib";
import React from 'react';
import { valueRange, midPoint } from '../redux/scales';
import s from './LoveHeart.scss';
var BrokenHeart = /** @class */ (function (_super) {
    tslib_1.__extends(BrokenHeart, _super);
    function BrokenHeart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrokenHeart.prototype.render = function () {
        var _a = this.props, lovePercentage = _a.lovePercentage, size = _a.size;
        // there is some number wizardry going on here to math out the
        // offset the two heart-halves to be for a particular score
        // this is roughly the distance between the hearts by default
        var maxOffset = size / 16;
        // where we are in our range, as percentage...
        var offsetPercentage = 1 - (valueRange - lovePercentage) / midPoint;
        // when close to the midpoint, switch to cracked heart
        if (offsetPercentage < 0.05) {
            return this.renderCrackedHeart(size);
        }
        // now we do the actual scaling of the offset, and shift if by half
        var offset = (offsetPercentage - 0.5) * maxOffset;
        return (React.createElement(React.Fragment, null,
            this.renderLeftHeart(offset, size),
            this.renderRightHeart(offset, size)));
    };
    BrokenHeart.prototype.renderCrackedHeart = function (imageSize) {
        return (React.createElement("svg", { width: imageSize, height: imageSize, viewBox: "0 0 160 160", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("g", { opacity: ".65", stroke: "#FFF", strokeLinecap: "square", strokeWidth: "2" },
                    React.createElement("path", { d: "M76.76 76.42l-6.26-5.57 10-12 2.67-3c7.74-7.49 20.052-7.402 27.684.197 7.632 7.6 7.773 19.911.316 27.683l-30.86 31.35a.11.11 0 0 1-.19-.11l8.37-27.9-11.73-10.65z" }),
                    React.createElement("path", { d: "M70.5 71.09l8.75-10.7.65-.83s-3-3.46-3.5-3.94c-7.784-7.35-20.001-7.182-27.58.38a19.61 19.61 0 0 0 0 27.88l31 31L88.5 87.1l-18-16" })))));
    };
    BrokenHeart.prototype.renderLeftHeart = function (offset, imageSize) {
        return (React.createElement("svg", { className: s['left-heart'], style: { transform: "translate(" + -offset + "px, 0)" }, width: imageSize, height: imageSize, viewBox: "0 0 160 160", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("g", { opacity: ".65", stroke: "#FFF", strokeLinecap: "square", strokeWidth: "2" },
                    React.createElement("path", { d: "M66.488 71.845l8.75-10.7.65-.83s-3-3.46-3.5-3.94c-7.797-7.33-20.007-7.14-27.57.43a19.61 19.61 0 0 0 0 27.88l31 31 8.67-27.82-18-16" })))));
    };
    BrokenHeart.prototype.renderRightHeart = function (offset, imageSize) {
        return (React.createElement("svg", { className: s['right-heart'], style: { transform: "translate(" + offset + "px, 0)" }, width: imageSize, height: imageSize, viewBox: "0 0 160 160", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("g", { opacity: ".65", stroke: "#FFF", strokeLinecap: "square", strokeWidth: "2" },
                    React.createElement("path", { d: "M83.26 76.13L77 70.56l10-12 2.67-3c7.74-7.49 20.052-7.402 27.684.198 7.632 7.6 7.773 19.91.316 27.683l-30.86 31.35a.11.11 0 0 1-.2-.08l8.37-27.9-11.72-10.68z" })))));
    };
    return BrokenHeart;
}(React.Component));
export { BrokenHeart };
export default BrokenHeart;
//# sourceMappingURL=BrokenHeart.js.map